<template>
  <van-popup v-model="showUnit" position="bottom" class="unit-popup">
    <div class="top">
      <div class="btn" @click="showUnit = false">取消</div>
      <div class="btn" @click="confirm">确定</div>
    </div>
    <no-data style="padding-bottom: 50px" v-if="list.length == 0"></no-data>
    <div v-else class="list-wrp" ref="listWrp">
      <van-checkbox-group v-model="radio" class="list" ref="list">
        <div class="list-item" v-for="(item, i) in list" :key="i">
          <van-checkbox :name="i">
            <div :class="radio==i ? 'main selected' : 'main'">
              <div class="name">{{ item.materialName }}</div>
              <!-- <div class="info">
                <div class="label">项目代码</div>
                <div class="text">{{ item.gcbh }}</div>
              </div>
              <div class="info">
                <div class="label">项目详细地点</div>
                <div class="text">{{ item.gcxxdd }}</div>
              </div> -->
            </div>
          </van-checkbox>
        </div>
      </van-checkbox-group>
    </div>
  </van-popup>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from "@/utils/api/appoint";
import {mapGetters} from 'vuex'
export default {
  components: { 
    NoData,
  },
  props: {
    title:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      showUnit: false,
      searchValue: '',
      params: {
        page: 1,
        rows: 10,
        search: ""
      },
      list: [],
      fillMap: {},
      canscroll: true, 
      activeisload: true,
      radio: [],
    };
  },
  watch: {
    showUnit(val) {
      if(val) {
        this.$nextTick(()=>{
          this.radio=[]
          this.getUnitList()
        })
        // this.$nextTick(() => {
        //   let listWrp = this.$refs['listWrp']
        //   let list = this.$refs['list'].$el
        //   console.log(this.$refs, list, listWrp, listWrp.offsetHeight)
        //   listWrp.addEventListener("scroll", () => {
        //     if (this.canscroll) {
        //       let scroll_top = listWrp.scrollTop
        //       let list_height = list.offsetHeight
        //       let w_height = listWrp.offsetHeight
              
        //       // console.log(list_height, scroll_top + w_height, list_height - (scroll_top + w_height) < 100)
        //       if (list_height - (scroll_top + w_height) < 100) {
        //         this.canscroll = false; //锁定滚动触发条件
        //         if (this.activeisload) {
        //           this.params.page++
        //           this.getUnitList()
        //         } else {
        //           console.log("已加载完所有已收藏的商品");
        //         }
        //       }
        //     }
        //   })
        // })
      }
    }
  },
  computed: {
    ...mapGetters('form', ['getFormConfigByName']),
  },
  methods: {
    search(val) {
      console.log('搜索值', val)
      this.params.search = val
      this.getUnitList()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.params.search = ''
      this.getUnitList()
    },
    confirm() {
      let data=[]
      for(const key of this.radio){
        data=data.concat(this.list[key].files)
        // data.push(this.list[key].files)
      }
      this.$emit('confirm',data)
      // let data = this.list[this.radio]
      // console.log(data)
      // for(let key in data) {
      //   let upKey = key.toLocaleUpperCase()
      //   if(Object.prototype.hasOwnProperty.call(this.$parent.componentData, upKey)) {
      //     this.$parent.componentData[upKey] = data[key]
      //   }
      // }
      // for(let key in this.fillMap) {
      //   this.$parent.componentData[key] = data[this.fillMap[key]]
      // }
      this.showUnit = false
    },
    getUnitList() {
      const data= this.getFormConfigByName('CommonFormFinal')
      const params = {
        materialName:this.title,
        projectNumber:data.data.GCBH
      }
      api.getHistoryMaterial(params).then(res=>{
        this.list=res.data.commonMaterial
      })
      // api.getHistoryProject(this.params).then(res => {
      //   let data = res.data
      //   this.fillMap = data.fillMap
      //   if (data.rowsList.length) {
      //     this.list = this.list.concat(data.rowsList);
      //     if (data.rowsList.length < this.params.rows) {
      //       this.activeisload = false;
      //       console.log("已加载完");
      //     } else {
      //       this.canscroll = true;
      //     }
      //   }
      // })
    },
  },
  created() {
    this.getUnitList()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.unit-popup {
  .top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #E5E5E5;
    .btn {
      padding: 8px 15px;
      color: #1D84FF;
      &:first-child {
        color: #999;
      }
    }
  }
  .list-wrp {
    width: 100%;
    height: 60vh;
    overflow-y: auto;
    .list {
      height: auto;
      &-item {
        padding: 0 10px 10px;
        ::v-deep .van-checkbox__label {
          flex: 1;
        }
        .main {
          padding: 20px 10px;
          border-bottom: 1px solid #EFEFEF;
          // &.selected {
          //   border: 1px solid #1D84FF;
          //   background-color: #F9FBFF;
          // }
          .name {
            font-size: 14px;
            font-weight: 500;
            color: #1D84FF;
          }
          .info {
            margin-top: 5px;
            font-size: 14px;
            color: #999;
            display: flex;
            align-items: flex-start;
            .label {
              width: 90px;
              text-align: right;
              padding-right: 10px;
            }
            .text {
              flex: 1;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>